/**
 * Dah Back Office API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RoleModel { 
    id?: string;
    name?: string;
    description?: string;
    adminRole?: boolean;
    ownRole?: boolean;
    permissions?: Array<RoleModel.PermissionsEnum>;
}
export namespace RoleModel {
    export const PermissionsEnum = {
        FeedbackAdmin: 'FEEDBACK_ADMIN',
        ManagersRead: 'MANAGERS_READ',
        ManagersEdit: 'MANAGERS_EDIT',
        AddressDictionaryAdd: 'ADDRESS_DICTIONARY_ADD',
        AddressDictionaryEdit: 'ADDRESS_DICTIONARY_EDIT',
        UserDelete: 'USER_DELETE',
        UserRead: 'USER_READ',
        AssociationAdd: 'ASSOCIATION_ADD',
        AssociationEdit: 'ASSOCIATION_EDIT',
        AssociationDelete: 'ASSOCIATION_DELETE',
        BuildingEdit: 'BUILDING_EDIT',
        ContactRead: 'CONTACT_READ',
        ContactAdd: 'CONTACT_ADD',
        ContactEdit: 'CONTACT_EDIT',
        ContactDelete: 'CONTACT_DELETE',
        ContactOwnRead: 'CONTACT_OWN_READ',
        ContactOwnAdd: 'CONTACT_OWN_ADD',
        ContactOwnEdit: 'CONTACT_OWN_EDIT',
        ContactOwnDelete: 'CONTACT_OWN_DELETE',
        TaskRead: 'TASK_READ',
        TaskAdd: 'TASK_ADD',
        TaskEdit: 'TASK_EDIT',
        TaskDelete: 'TASK_DELETE',
        TaskOwnRead: 'TASK_OWN_READ',
        TaskOwnAdd: 'TASK_OWN_ADD',
        TaskOwnEdit: 'TASK_OWN_EDIT',
        TaskOwnDelete: 'TASK_OWN_DELETE',
        CrmSettingsEdit: 'CRM_SETTINGS_EDIT',
        CrmSettingsRead: 'CRM_SETTINGS_READ',
        CrmResponsibleEdit: 'CRM_RESPONSIBLE_EDIT',
        CrmManagerEdit: 'CRM_MANAGER_EDIT',
        ProjectRead: 'PROJECT_READ',
        ProjectAdd: 'PROJECT_ADD',
        ProjectEdit: 'PROJECT_EDIT',
        ProjectDelete: 'PROJECT_DELETE',
        ProjectOwnRead: 'PROJECT_OWN_READ',
        ProjectOwnAdd: 'PROJECT_OWN_ADD',
        ProjectOwnEdit: 'PROJECT_OWN_EDIT',
        ProjectOwnDelete: 'PROJECT_OWN_DELETE',
        FeedAdd: 'FEED_ADD',
        FeedEdit: 'FEED_EDIT',
        FeedDelete: 'FEED_DELETE',
        FeedOwnEdit: 'FEED_OWN_EDIT',
        FeedOwnDelete: 'FEED_OWN_DELETE',
        CallRead: 'CALL_READ',
        CallOwnRead: 'CALL_OWN_READ',
        CrmLead: 'CRM_LEAD',
        FinancialMonitoring: 'FINANCIAL_MONITORING',
        AssociationTariffEdit: 'ASSOCIATION_TARIFF_EDIT',
        AssociationCabinetAccess: 'ASSOCIATION_CABINET_ACCESS',
        MessengerRead: 'MESSENGER_READ',
        MessengerDelete: 'MESSENGER_DELETE',
        ReadUserProfile: 'READ_USER_PROFILE',
        PublicationCommentsRead: 'PUBLICATION_COMMENTS_READ',
        CompanyClassifierEdit: 'COMPANY_CLASSIFIER_EDIT',
        VersionEventRead: 'VERSION_EVENT_READ',
        VersionEventEdit: 'VERSION_EVENT_EDIT',
        AccountingMonitorRead: 'ACCOUNTING_MONITOR_READ',
        AccountingMonitorReadOwn: 'ACCOUNTING_MONITOR_READ_OWN',
        BillingNewRead: 'BILLING_NEW_READ',
        BillingNewEdit: 'BILLING_NEW_EDIT',
        BillingNewActRead: 'BILLING_NEW_ACT_READ',
        BillingNewActEdit: 'BILLING_NEW_ACT_EDIT',
        BillingNewTransactionRead: 'BILLING_NEW_TRANSACTION_READ',
        BillingNewTransactionEdit: 'BILLING_NEW_TRANSACTION_EDIT',
        BillingNewSignEdit: 'BILLING_NEW_SIGN_EDIT',
        BillingSingleContractEdit: 'BILLING_SINGLE_CONTRACT_EDIT',
        OrgManagerRead: 'ORG_MANAGER_READ',
        OrgManagerEdit: 'ORG_MANAGER_EDIT',
        UserApartmentEdit: 'USER_APARTMENT_EDIT',
        UserApartmentRead: 'USER_APARTMENT_READ',
        AssociationHelpDeskEdit: 'ASSOCIATION_HELP_DESK_EDIT',
        AssociationHelpDeskRead: 'ASSOCIATION_HELP_DESK_READ',
        AssociationGovernmentEdit: 'ASSOCIATION_GOVERNMENT_EDIT',
        AssociationGovernmentRead: 'ASSOCIATION_GOVERNMENT_READ',
        ApartmentEdit: 'APARTMENT_EDIT',
        ApartmentRead: 'APARTMENT_READ',
        PublicationAdd: 'PUBLICATION_ADD',
        PublicationDelete: 'PUBLICATION_DELETE',
        PublicationRead: 'PUBLICATION_READ',
        PublicationSettingsEdit: 'PUBLICATION_SETTINGS_EDIT',
        PublicationCommentsDelete: 'PUBLICATION_COMMENTS_DELETE',
        AccountingTaxReportRead: 'ACCOUNTING_TAX_REPORT_READ',
        AccountingTaxReportEdit: 'ACCOUNTING_TAX_REPORT_EDIT',
        AcReceipts: 'AC_RECEIPTS',
        OrderSettingsEdit: 'ORDER_SETTINGS_EDIT',
        OrderDelete: 'ORDER_DELETE',
        OrderManager: 'ORDER_MANAGER',
        OrderRead: 'ORDER_READ',
        OrgDocumentRead: 'ORG_DOCUMENT_READ',
        OrgDocumentEdit: 'ORG_DOCUMENT_EDIT',
        SettingsNotificationEdit: 'SETTINGS_NOTIFICATION_EDIT',
        SettingsMainEdit: 'SETTINGS_MAIN_EDIT',
        DashboardRead: 'DASHBOARD_READ',
        OwnerNotificationEdit: 'OWNER_NOTIFICATION_EDIT',
        MeetingRead: 'MEETING_READ',
        MeetingEdit: 'MEETING_EDIT',
        OrgDahDocumentRead: 'ORG_DAH_DOCUMENT_READ',
        OrgDahDocumentEdit: 'ORG_DAH_DOCUMENT_EDIT',
        AcAccrualDocRead: 'AC_ACCRUAL_DOC_READ',
        AcAccrualDocEdit: 'AC_ACCRUAL_DOC_EDIT',
        AcAdjustmentDocRead: 'AC_ADJUSTMENT_DOC_READ',
        AcAdjustmentDocEdit: 'AC_ADJUSTMENT_DOC_EDIT',
        AcOrgCounterRead: 'AC_ORG_COUNTER_READ',
        AcOrgCounterEdit: 'AC_ORG_COUNTER_EDIT',
        AcOrgCounterIndRead: 'AC_ORG_COUNTER_IND_READ',
        AcOrgCounterIndEdit: 'AC_ORG_COUNTER_IND_EDIT',
        AcAptCounterRead: 'AC_APT_COUNTER_READ',
        AcAptCounterEdit: 'AC_APT_COUNTER_EDIT',
        AcAptCounterIndRead: 'AC_APT_COUNTER_IND_READ',
        AcAptCounterIndEdit: 'AC_APT_COUNTER_IND_EDIT',
        AcTariffRead: 'AC_TARIFF_READ',
        AcTariffEdit: 'AC_TARIFF_EDIT',
        AcTransactionRead: 'AC_TRANSACTION_READ',
        AcTransactionEdit: 'AC_TRANSACTION_EDIT',
        AcNomenclatureRead: 'AC_NOMENCLATURE_READ',
        AcNomenclatureEdit: 'AC_NOMENCLATURE_EDIT',
        AcNomenclatureDocRead: 'AC_NOMENCLATURE_DOC_READ',
        AcNomenclatureDocEdit: 'AC_NOMENCLATURE_DOC_EDIT',
        AcAssetRead: 'AC_ASSET_READ',
        AcAssetEdit: 'AC_ASSET_EDIT',
        AcAssetDocRead: 'AC_ASSET_DOC_READ',
        AcAssetDocEdit: 'AC_ASSET_DOC_EDIT',
        AcStaffDocRead: 'AC_STAFF_DOC_READ',
        AcStaffDocEdit: 'AC_STAFF_DOC_EDIT',
        AcWageAccDocRead: 'AC_WAGE_ACC_DOC_READ',
        AcWageAccDocEdit: 'AC_WAGE_ACC_DOC_EDIT',
        AcFlowItemRead: 'AC_FLOW_ITEM_READ',
        AcFlowItemEdit: 'AC_FLOW_ITEM_EDIT',
        AcCompanyRead: 'AC_COMPANY_READ',
        AcCompanyEdit: 'AC_COMPANY_EDIT',
        AcPersonRead: 'AC_PERSON_READ',
        AcPersonEdit: 'AC_PERSON_EDIT',
        AcPositionRead: 'AC_POSITION_READ',
        AcPositionEdit: 'AC_POSITION_EDIT',
        AcEmployeeRead: 'AC_EMPLOYEE_READ',
        AcEmployeeEdit: 'AC_EMPLOYEE_EDIT',
        AcStorageRead: 'AC_STORAGE_READ',
        AcStorageEdit: 'AC_STORAGE_EDIT',
        AcBalanceAccRead: 'AC_BALANCE_ACC_READ',
        AcBalanceAccEdit: 'AC_BALANCE_ACC_EDIT',
        AcClosePeriodDocRead: 'AC_CLOSE_PERIOD_DOC_READ',
        AcClosePeriodDocEdit: 'AC_CLOSE_PERIOD_DOC_EDIT',
        AcAccEntryRead: 'AC_ACC_ENTRY_READ',
        AcAccEntryEdit: 'AC_ACC_ENTRY_EDIT',
        AcScheduleRead: 'AC_SCHEDULE_READ',
        AcScheduleEdit: 'AC_SCHEDULE_EDIT',
        AcCalendarRead: 'AC_CALENDAR_READ',
        AcCalendarEdit: 'AC_CALENDAR_EDIT',
        AcMoneyAccRead: 'AC_MONEY_ACC_READ',
        AcMoneyAccEdit: 'AC_MONEY_ACC_EDIT',
        AcPaymentSystemRead: 'AC_PAYMENT_SYSTEM_READ',
        AcPaymentSystemEdit: 'AC_PAYMENT_SYSTEM_EDIT',
        AcInitialsRead: 'AC_INITIALS_READ',
        AcInitialsEdit: 'AC_INITIALS_EDIT',
        AcSettingsEdit: 'AC_SETTINGS_EDIT',
        AcCompanyReconciliationActRead: 'AC_COMPANY_RECONCILIATION_ACT_READ',
        AcCompanyReconciliationActEdit: 'AC_COMPANY_RECONCILIATION_ACT_EDIT',
        AcEstimateDocumentRead: 'AC_ESTIMATE_DOCUMENT_READ',
        AcEstimateDocumentEdit: 'AC_ESTIMATE_DOCUMENT_EDIT',
        AcBalancesFile: 'AC_BALANCES_FILE',
        AcBalanceReportRead: 'AC_BALANCE_REPORT_READ',
        SupportPostAdd: 'SUPPORT_POST_ADD',
        SupportPostEdit: 'SUPPORT_POST_EDIT',
        SupportPostDelete: 'SUPPORT_POST_DELETE',
        SupportTicketRead: 'SUPPORT_TICKET_READ',
        SupportTicketEdit: 'SUPPORT_TICKET_EDIT',
        SupportTicketDelete: 'SUPPORT_TICKET_DELETE',
        SupportTicketEditOwn: 'SUPPORT_TICKET_EDIT_OWN'
    } as const;
    export type PermissionsEnum = typeof PermissionsEnum[keyof typeof PermissionsEnum];
}


